import { render, staticRenderFns } from "./OrderDetailFood.vue?vue&type=template&id=5ea14ca0&scoped=true"
import script from "./OrderDetailFood.vue?vue&type=script&lang=js"
export * from "./OrderDetailFood.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailFood.vue?vue&type=style&index=0&id=5ea14ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea14ca0",
  null
  
)

export default component.exports